import React, { Component } from "react";
import { Row, Col, Button } from "reactstrap";

import DocView from "./DocView";
import PDFJSBackend from "../../backends/pdfjs.js";

export default class Documents extends Component {
  state = {
    currInd: 0
  };

  render() {
    return (
      <div>
        <Row>
          <Col
            style={{
              marginTop: 45,
              paddingLeft: 60,
            }}
          >
            <h1 style={{color: "#024563", textAlign: 'center'}}>Documents</h1>
          </Col>
        </Row>
        <Row
          style={{
            paddingLeft: "8%",
            paddingRight: "8%",
            paddingTop: "20px",
          }}
        >
          {this.props.docs.map((doc, index) => (
            <Button
              style={{
                fontFamily: this.state.hoverIndex === index ? 'Aptos-bold' : 'Aptos',
                border: "rgb(0, 0, 0, 0)",
                borderRadius:0,
                fontSize: "0.8vw",
                width: "7.1%",
                minWidth: "80px",
                backgroundColor:
                  this.state.currInd === index ? "#ebebeb" : "white",
                color: this.state.currInd === index ? "#024563" : "gray",
                borderBottom: this.state.currInd === index ? "4px solid #08bbfc" : "3px solid #ebebeb", // Bottom border color based on active state
                transition: 'font 0.3s ease' // Smooth transition for font-weight change
              }}
              onClick={() => {
                this.updateActive(index);
              }}
              onMouseEnter={() => this.setState({ hoverIndex: index })} // Set hover state
              onMouseLeave={() => this.setState({ hoverIndex: null })} // Reset hover state
            >
              {doc}
            </Button>
          ))}
        </Row>
        <DocView
          backend={PDFJSBackend}
          src={`/documents${this.props.pdfs[this.state.currInd][0]}.pdf`}
        />
      </div>
    );
  }

  updateActive = (ind) => {
    this.setState({ currInd: ind });
    //for some reason won't update otherwise
    let doc = document.querySelector("#iframeDoc");
    let file = `/documents${this.props.pdfs[ind][0]}.pdf`;
    doc.src = `/pdfjs-2-3/web/viewer.html?file=${file}`;
  };
}
